<template>
    <div class="mt-6 mb-4 status-legend-section pa-4">
        <div class="mr-3 legend-title font-weight-bold">
            {{ $t("deforestation.statusLegend") }}
            <v-tooltip top color="00BD73" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon size="16" class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs"
                        v-on="on">
                        mdi-information
                    </v-icon>
                </template>
                <span>{{ $t("deforestation.statusLegendInfo") }}</span>
            </v-tooltip>
        </div>
        <div class="flex-wrap mt-2 legend-items d-flex align-center">
            <template>
                <div class="mb-2 mr-4 legend-item d-inline-flex align-center" v-if="isDdsExporter">
                    <img src="/icons/dds/pending.svg" style="width: 20px; height: 20px; margin-right: 5px;" />
                    <span>{{ $t("deforestation.pendingOrNewlyReceived") }} </span>
                </div>
                <div class="mb-2 mr-4 legend-item d-inline-flex align-center" v-else>
                    <img src="/icons/dds/sent.svg" style="width: 20px; height: 20px; margin-right: 5px;" />
                    <span>{{ $t("deforestation.sentToExporter") }}</span>
                </div>
                <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                    <img src="/icons/dds/overdue.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                        $t("deforestation.overdue") }}
                </span>
            </template>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/updaterequired.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.updateRequired") }}
            </span>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/pendingApproval.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.pendingApproval") }}
            </span>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/ptsiapproved.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.approved") }}
            </span>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/temporaryApproved.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.temporaryApproved") }}
            </span>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/rejected.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.rejected") }}
            </span>
            <span class="mb-2 mr-4 legend-item d-inline-flex align-center">
                <img src="/icons/dds/shipment.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{
                    $t("deforestation.shipmentInProcess") }}
            </span>
        </div>
        <div>
            <ul> 
                <li class="legend-label">
                    <span> {{ $t("approvalFlow.cooperative.overdueTimeLegend") }} </span> 
                    <a 
                        v-if="canChangeOverdueTime"
                        style="text-decoration: underline; cursor: pointer;"
                        @click="navigateToSettings"
                    >
                        {{ $t("approvalFlow.cooperative.changeOverdueTime") }}
                    </a>
                </li>
                <li class="legend-label"><span> {{ $t("approvalFlow.cooperative.pendingComplianceLegend") }} </span></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { currentRoles } from '@/utils';

export default {
    props: {
        isDdsExporter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        canChangeOverdueTime() {
            const roles = currentRoles();
            return roles && (roles.includes('indonesia_ptsi') || roles.includes('kenya_ptsi'));
        }
    },
    methods: {
        navigateToSettings() {
            this.$router.push({ name: 'root_settings' });
        }
    }
}
</script>

<style lang="scss" scoped>
.status-legend-inline {
    font-size: 14px;
    flex-wrap: wrap;
}

.legend-label {
    color: #222;
}

.legend-item {
    white-space: nowrap;
    font-size: 14px;
}

.status-legend-section {
    background: #f8f9fa;
    border-radius: 10px;
    flex-wrap: wrap;
    font-size: 14px;
}

.legend-title {
    color: #222;
}

.legend-item {
    white-space: nowrap;
    font-size: 15px;
}
</style>